import '../styles/ShipmentsWorkspaceShell.css';
import React, { useState } from 'react';

/* 1.5px-stroke technical pictograms drawn on a 24px grid. */
function ShipmentsPictogram() {
  return (
    <svg className="ws-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true" focusable="false">
      <path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5v-9Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M3 7.5 12 12l9-4.5M12 12v9" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
}

function NewConsignmentPictogram() {
  return (
    <svg className="ws-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true" focusable="false">
      <rect x="3" y="6" width="18" height="14" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <path d="M3 10.5h18" stroke="currentColor" strokeWidth="1.5" />
      <path d="M12 12.5v5M9.5 15h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

function CustodyPictogram() {
  return (
    <svg className="ws-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true" focusable="false">
      <circle cx="12" cy="9" r="3.5" stroke="currentColor" strokeWidth="1.5" />
      <path d="M4.5 20c0-4 3.4-6.5 7.5-6.5s7.5 2.5 7.5 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M17.5 3.5l1.2 1.2L21 2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function ConfigurationPictogram() {
  return (
    <svg className="ws-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true" focusable="false">
      <path d="M5 7h14M5 12h14M5 17h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="9" cy="7" r="2.2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="15" cy="12" r="2.2" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="8" cy="17" r="2.2" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}

/* Workspace destinations only — no records, counts, filters or row controls. */
const WS_MODULES = [
  { id: 'shipments', label: 'Shipments', Icon: ShipmentsPictogram },
  { id: 'new-consignment', label: 'New consignment', Icon: NewConsignmentPictogram },
  { id: 'custody', label: 'Custody', Icon: CustodyPictogram },
  { id: 'configuration', label: 'Service configuration', Icon: ConfigurationPictogram },
];

const PANEL_ID = 'ws-workspace-modules';

function ShipmentsWorkspaceShell() {
  const [expanded, setExpanded] = useState(false);
  const [activeModule, setActiveModule] = useState('shipments');

  return (
    <section
      className={'ws-shell' + (expanded ? ' is-expanded' : '')}
      aria-label="Shipment workspace modules"
    >
      <div className="ws-strip">
        <div className="ws-head">
          <span className="ws-head-rule" aria-hidden="true" />
          <span className="ws-head-text">
            <h2 className="ws-head-title">Workspace</h2>
            <span className="ws-head-sub">Fast Forward Deliver Services</span>
          </span>
        </div>

        <ul className="ws-list" id={PANEL_ID}>
          {WS_MODULES.map(({ id, label, Icon }) => {
            const isActive = id === activeModule;
            return (
              <li className="ws-item" key={id}>
                <button
                  type="button"
                  className={'ws-entry' + (isActive ? ' is-active' : '')}
                  aria-pressed={isActive}
                  onClick={() => setActiveModule(id)}
                >
                  <Icon />
                  <span className="ws-label">{label}</span>
                </button>
              </li>
            );
          })}
        </ul>

        <button
          type="button"
          className="ws-collapse"
          aria-expanded={expanded}
          aria-controls={PANEL_ID}
          aria-label={expanded ? 'Collapse workspace rail' : 'Expand workspace rail'}
          onClick={() => setExpanded((open) => !open)}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
            <path
              d={expanded ? 'M14.5 6.5 9 12l5.5 5.5' : 'M9.5 6.5 15 12l-5.5 5.5'}
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </section>
  );
}

export default ShipmentsWorkspaceShell;